define("Room4.CCACategoryDescriptionFooter.CategoryDescriptionEntry", [
  "Room4.CCACategoryDescriptionFooter.CategoryDescriptionFooter.View",
], function (CategoryDescriptionFooterView) {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      /** @type {LayoutComponent} */
      var layout = container.getComponent("Layout");

      if (layout) {
        layout.addChildView(
          "Facets.Browse.CategoryHeading.Bottom",
          function () {
            return new CategoryDescriptionFooterView({ container: container });
          }
        );
      }
    },
  };
});
